export default __webpack_public_path__ + "static/media/led2_down.3ed24c06.svg";